import AddressSummary from './AddressSummary';

export default AddressSummary;
